export const TabActionReports = (data, id, sideNavKey, childActiveId) => {
    return {
        type: 'Open_Report_Tab',
        payload: {
            data: data,
            id: id ? id : undefined,
            sideNavKey: sideNavKey,
            childActiveId: childActiveId
        },
    }
}
export const ReportsRecordAction = (Data) => {
    return {
        type: 'ReportsRecordAction',
        payload: Data
    }
}